<template>
  <div class="info-popup" :class="position" :style="{ width: dynamicPopupWidth }">
    <div class="info-mini-container">
      <slot></slot>
      <div class="resize-handle" :class="position" @mousedown="startResize"></div>
      <div v-if="isResizing" class="overlay" @mousemove="handleResize" @mouseup="stopResize"></div>
    </div>
  </div>
</template>

<script>
export default {
    name: "ResizableContainer",
    props: {
      position: {
        type: String,
        default: 'right',
        validator: (val) => ['left', 'right'].includes(val)
      }
    },
    data() {
        return {
            isResizing: false,
            popupWidth: 600,
        };
    },
    created() {
        window.addEventListener("resize", this.handleWindowResize);
    },
    unmounted() {
        window.removeEventListener("resize", this.handleWindowResize);
    },
    computed: {
        dynamicPopupWidth() {
            return window.innerWidth < 992 ? "100%" : this.popupWidth + "px";
        },
    },
    methods: {
        startResize() {
            this.isResizing = true;
        },
        handleResize(e) {
            if (this.isResizing) {
                if (this.position === 'right') {
                  const newWidth = window.innerWidth - e.pageX;
                  this.popupWidth = newWidth;
                } else {
                  const newWidth = e.pageX;
                  this.popupWidth = newWidth;
                }
            }
        },
        stopResize() {
            this.isResizing = false;
        },
        handleWindowResize() {
            if (window.innerWidth < 992) {
                this.popupWidth = window.innerWidth;
            } else {
                this.popupWidth = 600;
            }
        },
    },
};
</script>

<style scoped>
.info-popup {
  position: absolute;
  top: 0;
  bottom: 0;
  max-height: 100%;
  background-color: var(--uq-light);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  min-width: 400px; /* Reduced min-width to be more flexible */
  overflow-y: auto;
}

.info-popup.right {
  right: 0;
}

.info-popup.left {
  left: 0;
}

.info-mini-container {
  position: relative;
  height: 100%;
}

.resize-handle {
    position: absolute;
    top: 0;
    width: 8px;
    cursor: ew-resize;
    background: #ccc;
    z-index: 111;
    height: 100%;
}

.resize-handle.right {
  left: -5px;
}

.resize-handle.left {
  right: -5px;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: ew-resize;
    z-index: 999;
}

@media (max-width: 992px) {
    .info-popup {
        min-width: 100%;
        padding: 0;
    }
}
</style>
